import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import classes from './Help.module.css';
import FAQLiefMan from 'assets/images/liefIcons/faq_lief.svg';
import HelpLiefMan from 'assets/images/liefIcons/help_lief.svg';
import VideoModal from 'components/Modals/VideoModal/VideoModal';
import HelpTile from 'containers/UI/HelpTile/HelpTile';
import { getMediaThumb } from 'shared/util';
import * as actions from 'store/actions';

class Help extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeVideoId: null,
      activeQuestionId: null,
      activeCategory: this.props.location.search === '?src=mobileapp' ? 'mobile' : 'web',
      // videoColumnWidth: 196,
      // leftColumnIndex: 0,
      searchInput: '',
    };
    this.activeVideo = React.createRef();
  }

  componentDidMount() {
    this.props.onFetchHelpContent();
  }

  toggleActiveQuestion = (activeQuestionId) => {
    if (this.state.activeQuestionId === activeQuestionId) {
      this.setState({ activeQuestionId: null });
    } else {
      this.setState({ activeQuestionId });
    }
  };

  toggleActiveVideo = (activeVideoId) => {
    if (this.state.activeVideoId === activeVideoId) {
      this.setState({ activeVideoId: null });
    } else {
      this.setState({ activeVideoId });
    }
  };

  handleSearchUpdate = (event) => {
    this.setState({ searchInput: event.target.value });
  };

  handleSearchClear = () => {
    this.setState({ searchInput: '' });
  };

  render = () => {
    let activeCategoryContent = null;
    const helpCategories = [
      { key: 'web', name: 'Web Videos' },
      { key: 'mobile', name: 'Mobile Videos' },
      { key: 'faq', name: 'FAQs' },
      { key: 'tips', name: 'Tips' },
    ];
    const isMobile = this.props.location.search === '?src=mobileapp';
    const currentVideo =
      this.props.HelpContent &&
      this.props.HelpContent[this.state.activeCategory] &&
      this.props.HelpContent[this.state.activeCategory].find((contentItem) => contentItem.Id === this.state.activeVideoId) &&
      this.props.HelpContent[this.state.activeCategory].find((contentItem) => contentItem.Id === this.state.activeVideoId).FileVideo
        ? this.props.HelpContent[this.state.activeCategory].find((contentItem) => contentItem.Id === this.state.activeVideoId)
        : null;

    if (this.state.activeCategory === 'faq') {
      activeCategoryContent = (
        <div className={classes.FAQList}>
          {this.props.HelpContent.faq
            ? this.props.HelpContent.faq
                .filter(
                  (contentItem) =>
                    contentItem.Name.toLowerCase().includes(this.state.searchInput.toLowerCase()) ||
                    contentItem.FullDesc.toLowerCase().includes(this.state.searchInput.toLowerCase()),
                )
                .map((faq) => (
                  <div key={`faq-${faq.Id}`} className={this.state.activeQuestionId === faq.Id ? [classes.FAQ, classes.Open].join(' ') : classes.FAQ}>
                    <div className={classes.Title} onClick={() => this.toggleActiveQuestion(faq.Id)}>
                      <h3>{faq.Name}</h3>
                      <FontAwesomeIcon
                        icon={this.state.activeQuestionId === faq.Id ? 'chevron-up' : 'chevron-down'}
                        className={classes.OpenCloseIcon}
                      />
                    </div>
                    <p>{faq.FullDesc}</p>
                  </div>
                ))
            : null}
        </div>
      );
    } else if (['mobile', 'web'].includes(this.state.activeCategory) && this.props.HelpContent[this.state.activeCategory]) {
      activeCategoryContent = (
        <div className={classes.HelpVideos}>
          {this.props.HelpContent[this.state.activeCategory]
            .filter(
              (contentItem) =>
                contentItem.Name.toLowerCase().includes(this.state.searchInput.toLowerCase()) ||
                contentItem.FullDesc.toLowerCase().includes(this.state.searchInput.toLowerCase()),
            )
            .map((video) => (
              <div key={`video-${video.Id}`} className={classes.HelpVideo}>
                <HelpTile
                  type="Help"
                  toggle={() => this.toggleActiveVideo(video.Id)}
                  videoUrl={video.FileVideo ? video.FileVideo.FileURL : ''}
                  imageUrl={video.FileImage ? getMediaThumb(video.FileImage) : ''}
                  id={video.Id}
                  videoHostName={video.ByDisplayName}
                  videoLengthInSeconds={video.FileVideo ? video.FileVideo.DurationInMs / 1000 : null}
                  showVideo={this.state.activeVideoId === video.Id}
                />
                <h2>{video.Name}</h2>
                <p>{video.FullDesc}</p>
              </div>
            ))}
        </div>
      );
    } else if (this.state.activeCategory === 'tips') {
      activeCategoryContent = (
        <div className={classes.Tips}>
          {this.props.HelpContent.tips
            .filter(
              (contentItem) =>
                contentItem.Name.toLowerCase().includes(this.state.searchInput.toLowerCase()) ||
                contentItem.FullDesc.toLowerCase().includes(this.state.searchInput.toLowerCase()),
            )
            .map((tip) => (
              <div key={tip.Name} className={classes.Tip}>
                <HelpTile
                  type="Help"
                  toggle={tip.FileVideo ? () => this.toggleActiveVideo(tip.Id) : null}
                  videoUrl={tip.FileVideo ? tip.FileVideo.FileURL : ''}
                  imageUrl={tip.FileImage ? getMediaThumb(tip.FileImage) : ''}
                  id={tip.Id}
                  videoHostName={tip.ByDisplayName}
                  videoLengthInSeconds={tip.FileVideo ? tip.FileVideo.DurationInMs / 1000 : null}
                  showVideo={this.state.activeVideoId === tip}
                />
                <div className={classes.Content}>
                  <h2>{tip.Name}</h2>
                  <p>{tip.FullDesc}</p>
                </div>
              </div>
            ))}
        </div>
      );
    }
    return (
      <div className={classes.Container}>
        {currentVideo !== null ? (
          <VideoModal
            show
            toggleVideo={currentVideo ? () => this.toggleActiveVideo(currentVideo.Id) : null}
            title={currentVideo && currentVideo.Name}
            videoUrl={currentVideo && currentVideo.FileVideo ? currentVideo.FileVideo.FileURL : ''}
            orientation={currentVideo && currentVideo.FileVideo && this.state.activeCategory === 'web' ? 'horizontal' : 'vertical'}
            isMobile={isMobile}
          />
        ) : null}
        <div className={classes.Header}>
          <h1>How can we help?</h1>
        </div>
        <div className={classes.TopSection}>
          <img className={classes.LiefMan} src={this.state.activeCategory === 'faqs' ? FAQLiefMan : HelpLiefMan} alt="help videos" />
        </div>
        <div className={classes.SearchContainer}>
          <div className={classes.SearchInputContainer}>
            <FontAwesomeIcon icon="search" className={classes.SearchIcon} onClick={this.handleFilter} />
            <input type="input" value={this.state.searchInput} onChange={this.handleSearchUpdate} className={classes.SearchInput} />
            {this.state.searchInput.length > 0 ? (
              <FontAwesomeIcon className={classes.ClearSearchIcon} onClick={this.handleSearchClear} icon="times-circle" />
            ) : null}
          </div>
          <div className={classes.CategoryTabs}>
            {helpCategories.map((category) => (
              <div
                key={`category-${category.key}`}
                className={this.state.activeCategory === category.key ? [classes.CategoryTab, classes.Selected].join(' ') : classes.CategoryTab}
                onClick={() => this.setState({ activeCategory: category.key })}
              >
                {category.name}
                {this.state.searchInput.length > 0 && this.props.HelpContent[category.key] && this.state.activeCategory !== category.key ? (
                  <span className={classes.ResultCount}>
                    (
                    {
                      this.props.HelpContent[category.key].filter(
                        (contentItem) =>
                          contentItem.Name.toLowerCase().includes(this.state.searchInput.toLowerCase()) ||
                          contentItem.FullDesc.toLowerCase().includes(this.state.searchInput.toLowerCase()),
                      ).length
                    }
                    )
                  </span>
                ) : null}
              </div>
            ))}
          </div>
          {this.state.searchInput.length > 0 && this.props.HelpContent[this.state.activeCategory] ? (
            <div className={classes.CategoryResultCount}>
              <hr />
              <p>
                {
                  this.props.HelpContent[this.state.activeCategory].filter(
                    (contentItem) =>
                      contentItem.Name.toLowerCase().includes(this.state.searchInput.toLowerCase()) ||
                      contentItem.FullDesc.toLowerCase().includes(this.state.searchInput.toLowerCase()),
                  ).length
                }{' '}
                results found
              </p>
            </div>
          ) : null}
        </div>
        <div className={classes.ContentContainer}>{activeCategoryContent}</div>

        <div className={classes.ContactUs}>
          <div className={classes.ContactUsWrapper}>
            <h2>Can’t find the answer?</h2>
            <p>If you cannot find the answer to your question, please send an email to help@riza.life.</p>
          </div>
        </div>
      </div>
    );
  };
}

const mapStateToProps = (state) => {
  return {
    loading: state.help.loading,
    HelpContent: state.help.HelpContent,
    HelpCount: state.help.HelpCount,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onFetchHelpContent: (HelpType) => dispatch(actions.fetchHelpContent(HelpType)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Help);
